import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "content_wrapper" }
const _hoisted_4 = { class: "pa-1 name-wrapper d-flex align-center" }
const _hoisted_5 = { class: "icon mr-2" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        class: "fixed_toolbar",
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            style: {"position":"absolute"},
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("児童票", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c) => {
        return (_openBlock(), _createElementBlock("div", {
          key: c.childId
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: c.imageUrl? c.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("h5", null, _toDisplayString(c.lastName) + _toDisplayString(c.firstName), 1)
          ]),
          _createVNode(_component_v_list, { density: "compact" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.title
                }, [
                  _createVNode(_component_v_list_item, {
                    onClick: ($event: any) => (_ctx.to( item.path, item.name, c.childId, c.lastName + c.firstName ))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, {
                        textContent: _toDisplayString(item.title)
                      }, null, 8, ["textContent"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_v_divider)
                ], 64))
              }), 128))
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ])
  ]))
}